import { useEffect, useState } from "react";
import { getActivities } from "../services/data.service";
import {
  Card,
  CardContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

const HowTo = () => {
  const [activities, setActivities] = useState([]);

  useEffect(() => {
    getActivities().then((activities) => {
      setActivities(Object.values(activities).map((a) => a.name));
    });
  }, []);

  return (
    <>
      <Stack spacing={2}>
        <Typography variant="h5" align="center">
          ¿Cómo enviar fotos para publicar?
        </Typography>

        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              ¿Quiénes pueden enviar?
            </Typography>
            <Typography variant="body2">
              Miembros de FOTONOBA que hayan participado de las muestras que
              estan publicadas en la galería y hayan completado el{" "}
              <a
                target="_blank"
                rel="noreferrer"
                href="https://docs.google.com/forms/d/e/1FAIpQLSeFuAAWbYp7qPaYXpbocUDvSdYQZQXiH3Y_uJ_inmmEy9XRHA/viewform?usp=dialog"
              >
                formulario de consentimiento
              </a>{" "}
              con sus datos de contacto.
            </Typography>
          </CardContent>
        </Card>

        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              ¿Por qué debo completar el formulario de consentimiento?
            </Typography>
            <Typography variant="body2">
              El formulario tiene como fin recabar la información que acompañará
              aquellas fotografías que nos envíen, para formar parte de la
              galería de fotos de la web de FOTONOBA. Dicha información es
              importante, para que los visitantes de la página puedan
              contactarlos, si así lo desearan. Por otro lado, se deja sentado,
              que el solo hecho de contestar y enviar este formulario, será
              CONSTANCIA DE CONSENTIMIENTO para la publicación de dichas fotos.
              FOTONOBA no se hace responsable de posibles hurtos de imágenes
              publicadas. Por su lado, FOTONOBA, se compromete a que quede usted
              debidamente nombrado, cada vez que se publique una fotografía de
              su autoría.
            </Typography>
          </CardContent>
        </Card>

        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Quiero modificar datos que envié en el formulario ¿qué debo
              hacer?
            </Typography>
            <Typography variant="body2">
              Los datos provistos en el formulario, pueden ser removidos o
              rectificados en cualquier momento. Para realizarlo, se debe enviar
              un mail a fotonobatecnologia@gmail.com o a fotonobaok@gmail.com.
              El único dato que no pedimos en el formulario, es la foto de
              perfil. La misma la obtenemos del perfil de instagram o facebook
              en caso de ser aportados. Al igual que cualquiera de los otros
              datos, puede ser removida o cambiada cuando se requiera.
            </Typography>
          </CardContent>
        </Card>

        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              ¿Qué fotos puedo enviar?
            </Typography>
            <Typography variant="body2">
              Estamos recibiendo fotos que hayan pasado por el proceso de
              selección realizado por los miembros de FOTONOBA y hayan formado
              parte de las siguientes actividades:
            </Typography>
            <List>
              {activities.map((a) => (
                <ListItem>
                  <ListItemIcon>
                    <FiberManualRecordIcon />
                  </ListItemIcon>
                  <ListItemText primary={a} />
                </ListItem>
              ))}
            </List>
          </CardContent>
        </Card>

        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              ¿En qué calidad debo enviar las fotos?
            </Typography>
            <Typography variant="body2">
              Las fotos se pueden enviar en calidad para publicar en redes
              sociales, tratando de que pesen lo menos posible para asegurar una
              carga y navegación efectiva del sitio. Cabe aclarar que no
              realizamos ningun tipo de modificación a las fotos que nos envíes,
              se suben tal cual las recibimos. El servicio de almacenamiento de
              imágenes que usamos, tiene un limite de tamaño para los archivos.
              Sólo en caso de que la foto supere ese límite, realizamos una
              compresión del archivo procurando la menor pérdida de calidad
              posible. Pero para tu tranquilidad, te informamos si realizamos
              este proceso y siempre tenés la última palabra en cuanto al
              resultado.
            </Typography>
          </CardContent>
        </Card>

        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              ¿Debo ponerles marca de agua o firma?
            </Typography>
            <Typography variant="body2">
              Cada vez que aparezca tu foto en el sitio, nos aseguramos de que
              tu nombre y foto de perfil se vean claramente para indicar la
              autoría. Podés incluir, si lo deseas, marca de agua o firma en las
              fotos que envíes, pero siempre recomendamos que la misma no sea
              muy invasiva, para que lo que se luzca sea la foto.
            </Typography>
          </CardContent>
        </Card>

        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              ¿A dónde debo enviar las fotos?
            </Typography>
            <Typography variant="body2">
              Si ya tenes las fotos que cumplen los requisitos para ser
              publicadas, las podés enviar por mail a
              fotonobatecnologia@gmail.com. En el mail, agradecemos si incluís
              una descripción de las fotos que estás enviando, para mostrar al
              pie de la foto cuando se ve en tamaño completo. Esto complementa
              muchísimo el trabajo realizado, y te da la posibilidad de aportar
              datos extra de la captura, algo de historia, o simplemente
              sentimientos y sensaciones que quieras aportar. En el transcurso
              de un par de días la subimos al sitio y te avisamos contestando el
              mismo correo, para que de esa manera, puedas chequear que este
              todo correctamente publicado.
            </Typography>
          </CardContent>
        </Card>

        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              ¿Cuándo se realizan las selecciones de nuevas fotos?
            </Typography>
            <Typography variant="body2">
              Estate atento a las redes sociales de FOTONOBA, o el canal de
              difusión de whatsapp, ahí publicamos novedades de todas las
              actividades que realizamos, incluídas las reuniones de selección
              de fotos.
            </Typography>
          </CardContent>
        </Card>
      </Stack>
    </>
  );
};

export default HowTo;
